import React from 'react';
import XLSX from 'xlsx';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import {
    saveObject,
    updateObject, getSalesforceToken, getApplyingToList, spmfcloudPostalFunctionUrl,
} from '../../actions/salesforces';

let temp = [];
let bodyData = [];
let apiData = [];
let apiHitRequired = 0;
let actualApiHitted = 0;
let totalRecordInserted = 0;
let count = 0;
const recordsPerApi = 40000;
class PostalDataUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            fileName: ''
        }
        this.uploadFile = this.uploadFile.bind(this);
        this.readFile = this.readFile.bind(this);
    }

    readFile(event) {
        temp = [];
        bodyData = [];
        this.setState({ loading: true });
        const file = event.target.files[0];
        this.setState({
            fileName: file.name.replace(' ', '_'),
        });

        const input = event.target;
        const reader = new FileReader();
        reader.onload = () => {
            const fileData = reader.result;
            const wb = XLSX.read(fileData, { type: 'binary' });
            wb.SheetNames.forEach((sheetName) => {
                const rowObj = XLSX.utils.sheet_to_row_object_array(wb.Sheets[sheetName]);
                const newRowObj = rowObj.map((obj) => {
                    if (obj.POSTCODE.toString().length < 6) obj.POSTCODE = `0${obj.POSTCODE}`;
                    else obj.POSTCODE = obj.POSTCODE.toString();
                    return obj;
                });
                const jsonObj = JSON.stringify(newRowObj);
                temp.push(jsonObj);
            });
        };
        reader.readAsBinaryString(input.files[0]);
        this.setState({ loading: false });
    }


    async deletePostalCodeApi() {
        const headers = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        };
        const fetchConfig = {
            method: 'GET',
            headers,
            timeout: 5000,
        };
        console.log('body');
        console.log(fetchConfig);
        const respo = fetch(`${spmfcloudPostalFunctionUrl}/api/deletePostalRecord`, fetchConfig).then(response => response.json());
        return respo;
    }


    async uploadFile() {
        bodyData = [];

        if (temp.length === 0) {
            swal({
                title: 'Error',
                text: 'Please Select a file',
            });
            return;
        }
        this.setState({ loading: true });
        const tempBody = JSON.parse(temp[0]);
        //   bodyData = temp[0]

        for (let i = 0; i < tempBody.length; i++) {
            const postcode = `${tempBody[i].POSTCODE}`;
            if (postcode.length < 5 || postcode.length > 6) {
                count++;
            } else {
                bodyData.push(tempBody[i]);
            }
        }
        actualApiHitted = 0;

        apiHitRequired = Math.floor(bodyData.length / recordsPerApi);
        this.deletePostalCodeApi().then((data) => {
            this.apiDataHitFunctionalty();
        });
    }

    apiDataHitFunctionalty() {
        apiData = [];
        console.log(apiHitRequired);
        console.log(actualApiHitted);
        if (bodyData.length < recordsPerApi) {
            apiData = JSON.stringify(bodyData, 0);
            this.postApiData();
        } else if (apiHitRequired === (actualApiHitted)) {
            console.log('enter in 2');

            for (let i = apiHitRequired * recordsPerApi; i < bodyData.length; i++) {
                apiData.push(bodyData[i]);
            }
            apiData = JSON.stringify(apiData);
            this.postApiData();
        } else if (apiHitRequired > (actualApiHitted)) {
            console.log('enter in 3');
            for (let i = actualApiHitted * recordsPerApi; i < (actualApiHitted + 1) * recordsPerApi; i++) {
                apiData.push(bodyData[i]);
            }
            apiData = JSON.stringify(apiData);
            this.postApiData();
        }
    }

    async postApiData() {
        const headers = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        };
        const fetchConfig = {
            method: 'POST',
            headers,
            body: apiData,
            timeout: 5000,
        };
        console.log('body');
        console.log(fetchConfig);
        const respo = await fetch(`${spmfcloudPostalFunctionUrl}/api/uploadPostal`, fetchConfig).then(response => response.json());
        totalRecordInserted += (+respo.data.insertedCount);
        if (+apiHitRequired === (+actualApiHitted)) {
            swal({
                title: 'Successfull',
                text: `${totalRecordInserted} Records Updated.\n${count > 0 ? ` Error in updating ${count} records.` : ''}`,
                // + count > 0 ? " Error in updating " + count + " records." : null
            });
            this.setState({ loading: false });
        } else {
            actualApiHitted++;
            this.apiDataHitFunctionalty();
        }
    }

    render() {
        return (
            <div className="registrationForm container-fluid">
                <div className="col-md-12" >
                    <div className="text-center">
                        <h2 style={{ color: '#0590ba' }}>&nbsp;&nbsp;Postal Data Upload</h2>
                    </div>
                </div>
                <div className="col-md-12" >
                    <div className="text-center">
                        <h6 style={{ color: '#0590ba' }}>{this.state.fileName}</h6>
                    </div>
                </div>

                <div className="col-md-12 print">
                    <div className="col-md-12" id="logoHeader">
                        <div className="text-center">
                            <div style={{ marginLeft: '46%' }} className="col-md-10">
                                <br />
                                <label className="fileContainer">
                                    Choose File
                                    <input
                                        onChange={this.readFile}
                                        onClick={(e) => { e.target.value = null; }}
                                        type="file"
                                        className="form-control-file"
                                        aria-describedby="fileHelp1"
                                        multiple
                                    />
                                </label>&nbsp;
                            </div>
                        </div>
                    </div>
                    <br /><br /><br />
                    <div className="row">
                        <br />
                        {/* Upload NRIC */}
                        <div className="text-center">
                            <div className="form-group">

                                <input
                                    type="button"
                                    className="btn btn-lg btn-fill btn-primary btn-wd"
                                    id="uploadFile"
                                    name="uploadFile"
                                    value="Upload File"
                                    onClick={this.uploadFile}
                                />
                            </div>
                        </div>
                    </div>
                    <p style={{ textAlign: 'center' }}>
                        {this.state.loading ? <i className="fa fa-5x fa-spinner fa-spin" /> : null}
                    </p>
                </div >
            </div >
        );
    }
}


const mapDispatchToProps = dispatch => (
    bindActionCreators({
        getSalesforceToken,
        saveObject,
        updateObject,
        getApplyingToList,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});


export default connect(mapStateToProps, mapDispatchToProps)(PostalDataUpload);




//////////////////
// WEBPACK FOOTER
// ./src/components/PostalDataUpload/postalDataUpload.js
// module id = 766
// module chunks = 0